import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Fade } from '@mui/material';
import { CheckCircle, ErrorOutline } from '@mui/icons-material';
import { capitalize } from '../../../utils/formatters/stringFormatter';

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style = {},
  markerEnd,
  selected,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const [hovered, setHovered] = useState(false);

  return (
    <>
      <g
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <BaseEdge
          id={id}
          path={edgePath}
          style={{
            ...style,
            // stroke: data?.isValid ? '#1976d2' : '#ff1744',
            stroke:
              style.stroke ||
              (selected ? '#fbbe00' : data?.isValid ? '#1976d2' : '#ff1744'),
            strokeWidth: 2,
            // filter: !data?.isValid ? 'drop-shadow(0 0 4px #ff1744)' : 'none',
            filter: selected
              ? 'drop-shadow(0 0 6px #fbbe00)'
              : !data?.isValid
              ? 'drop-shadow(0 0 4px #ff1744)'
              : 'none',
          }}
          markerEnd={markerEnd}
        />
      </g>

      {/* <EdgeLabelRenderer>
        <Fade in={hovered}>
          <Box
            sx={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: 'all',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 1,
              py: 0.5,
              borderRadius: 1,
              bgcolor: data?.isValid ? '#e3f2fd' : '#fdecea',
              border: `1px solid ${data?.isValid ? '#1976d2' : '#ff1744'}`,
              color: data?.isValid ? '#1976d2' : '#ff1744',
              boxShadow: 1,
              fontSize: 12,
              transition: 'all 0.3s ease',
              zIndex: 100,
            }}
          >
            <ErrorIcon fontSize="small" />
            <Typography variant="caption" noWrap>
              {data?.label || (data?.isValid ? 'Connected' : 'Type Mismatch')}
            </Typography>
          </Box>
        </Fade>
      </EdgeLabelRenderer> */}

      {hovered && (
        <EdgeLabelRenderer>
          <Fade in={hovered}>
            <Box
              sx={{
                position: 'absolute',
                transform: `translate(-50%, -120%) translate(${labelX}px, ${labelY}px)`,
                pointerEvents: 'all',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                bgcolor: data?.isValid ? '#e3f2fd' : '#fdecea',
                border: `1px solid ${data?.isValid ? '#1976d2' : '#ff1744'}`,
                color: data?.isValid ? '#1976d2' : '#ff1744',
                boxShadow: 1,
                p: 1,
                borderRadius: 1,
                minWidth: 120,
                fontSize: 15,
                zIndex: 99999,
                transition: 'all 0.3s ease',
                transformOrigin: 'center',
                '&:hover': {
                  boxShadow: 6,
                  transform: `translate(-50%, -85%) translate(${labelX}px, ${labelY}px) scale(1.05)`,
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={0.5}>
                {data?.isValid ? (
                  <CheckCircle fontSize="small" color="success" />
                ) : (
                  <ErrorOutline fontSize="small" color="error" />
                )}
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 500, fontSize: 14 }}
                >
                  {data?.label || (data?.isValid ? 'Valid' : 'Type Mismatch')}
                </Typography>
              </Box>
              {/* <Typography variant="caption" sx={{ fontSize: 18, opacity: 0.7 }}>
                {`${data?.sourceType || 'unknown'} → ${
                  data?.targetType || 'unknown'
                }`}
              </Typography> */}

              {/* <Typography variant="caption" sx={{ fontSize: 18, opacity: 0.7 }}>
                {data?.functionType
                  ? `(${data?.functionType}) ${data?.sourceType} → ${data.targetType}`
                  : `${data?.sourceType} → ${data?.targetType}`}
              </Typography> */}
              {/* <Typography variant="caption" sx={{ fontSize: 18, opacity: 0.7 }}>
               
                {`${
                  data?.functionSourceType
                    ? `(${capitalize(data.functionSourceType)}) `
                    : ''
                }[${
                  Array.isArray(data?.sourceType)
                    ? data.sourceType.join(', ')
                    : data?.sourceType || 'unknown'
                }] → [${
                  Array.isArray(data?.targetType)
                    ? data.targetType.join(', ')
                    : data?.targetType || 'unknown'
                }]`}
              </Typography> */}
              <Typography variant="caption" sx={{ fontSize: 18, opacity: 0.7 }}>
                {data?.isFuzzy
                  ? `${data?.sourceLabel || 'source'} → ${
                      data?.targetLabel || 'target'
                    }`
                  : `${
                      data?.functionSourceType
                        ? `(${capitalize(data.functionSourceType)}) `
                        : ''
                    }[${
                      Array.isArray(data?.sourceType)
                        ? data.sourceType.join(', ')
                        : data?.sourceType || 'unknown'
                    }] → [${
                      Array.isArray(data?.targetType)
                        ? data.targetType.join(', ')
                        : data?.targetType || 'unknown'
                    }]`}
              </Typography>
            </Box>
          </Fade>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

CustomEdge.propTypes = {
  id: PropTypes.string.isRequired,
  sourceX: PropTypes.number.isRequired,
  sourceY: PropTypes.number.isRequired,
  targetX: PropTypes.number.isRequired,
  targetY: PropTypes.number.isRequired,
  sourcePosition: PropTypes.any,
  targetPosition: PropTypes.any,
  data: PropTypes.shape({
    label: PropTypes.string,
    isValid: PropTypes.bool,
    isFuzzy: PropTypes.bool,
    sourceType: PropTypes.string,
    targetType: PropTypes.string,
    sourceLabel: PropTypes.string,
    targetLabel: PropTypes.string,
    functionSourceType: PropTypes.string,
    functionTargetType: PropTypes.string,
  }),
  style: PropTypes.object,
  markerEnd: PropTypes.any,
  selected: PropTypes.bool,
};

export default CustomEdge;
